import * as React from "react";
import {connect} from "react-redux";
import {ApplicationState} from "@reducers/index";
import {Form, Input, Tooltip, Icon, Row, Col,} from "antd";
import {Image} from "@models/image";
import ImagePicker from '@components/custom/imagePicker';
import {createRequest, updateRequest} from '@actions/person-role';
import {FormattedMessage} from 'react-intl';
import {PersonRole} from "@models/person-role";
import withFormWrapper from "@hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  personRole?: PersonRole
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
}

type PersonRoleFormAllProps = PropsFromState & PropsFromDispatch;

const mapStateToProps = ({images}: ApplicationState) => ({
  loading: images.loading,
  errors: images.errors
});


class PersonRoleForm extends React.Component<PersonRoleFormAllProps, PersonRoleFormStateShape> {
  
  constructor(props) {
    super(props);
    const {personRole} = this.props;
    this.state = {
      visible: false,
      title: personRole ? personRole.title : "",
      icon_image: personRole ? personRole.icon_image : null
    };
  }
  
  
  /**
   * Set cover and avatar ids in a form values to handle validation by form
   */
  getValues = () => {
    let returnValues = null;
    
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          icon_image_id: this.state.icon_image ? this.state.icon_image.id : null
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.props.personRole ? this.props.personRole.id : null
    };
  };
  
  setIconImage = (image: Image) => {
    this.setState({
      icon_image: image
    })
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={"role-form"}>
        <Row gutter={24}>
          <Col span={6}>
            <ImagePicker onSelectImage={this.setIconImage} selectedImage={this.state.icon_image}>
              <Tooltip title="prompt text">
                <div className={`image-wrapper icon-image`}
                     style={{
                       backgroundImage: `url(${
                         this.state.icon_image
                           ? this.state.icon_image.path
                           : ""
                         })`
                     }}
                >
                  <FormattedMessage id="app.icon_image" defaultMessage={`Icon Image`}/>
                </div>
              </Tooltip>
            </ImagePicker>
          </Col>
          <Col span={18}>
            <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`}/>}>
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.title_is_required"
                                             defaultMessage={`Title is required!`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}


type PersonRoleFormStateShape = {
  visible: boolean;
  title: string;
  icon_image?: Image | null,
}



export default withFormWrapper(Form.create({name: "person-role-form"})(PersonRoleForm))

